// src/onboarding/OnboardingChip.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

export default function OnboardingChip({label, selected, onClick}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      style={{
        borderRadius: 20,
        padding: "8px 16px",
        border: `1px solid ${selected ? "var(--c-heading)" : "var(--c-border)"}`,
        background: selected ? "var(--c-tint)" : "transparent",
        color: selected ? "var(--c-heading)" : "var(--c-text)",
        fontFamily: "inherit",
        fontSize: "var(--font-body)",
        fontWeight: selected ? 600 : 400,
        cursor: "pointer",
        minHeight: 40,
      }}
    >
      {label}
    </button>
  );
}
